import { Layout } from "@/components/layout"
import MaterialComplianceApp from "@/features/material-compliance/App"
import { MaterialComplianceNav } from "@/features/material-compliance/components/shared/MaterialComplianceNav"
import "@/features/material-compliance/index.css"

export default function MaterialCompliancePage() {
  return (
    <Layout headerLeftElement={<MaterialComplianceNav />}>
      <MaterialComplianceApp />
    </Layout>
  )
}
